/**
 * Logger factory methods
 */

import { TelemetrySink } from '@microsoft/oteljs'

import { setConsoleLogEnabled } from './console-log'
import { ConsoleLogSink } from './console-log-sink'
import { log } from './global-log'
import { Environment, IConfiguration } from './helpers/environment'
import { CustomLogData } from './interfaces'
import { setupConfiguration } from './logger-factory-helper'
import { initializeOtelWebLogger, OTelConfig } from './otel-sink'

export function initConsoleLog(forceEnable = false) {
  let shouldEnable = forceEnable

  const isLogEnabled = (params?: string | false) =>
    params && params.indexOf('owsclg') !== -1

  if (!shouldEnable) {
    // tslint:disable-next-line:no-typeof-undefined strict-type-predicates
    const queryParams = typeof window !== 'undefined' && window.location.search
    shouldEnable = !!isLogEnabled(queryParams)
  }

  if (!shouldEnable) {
    // tslint:disable-next-line:no-typeof-undefined strict-type-predicates
    const referrer = typeof document !== 'undefined' && document.referrer
    shouldEnable = !!isLogEnabled(referrer)
  }

  if (shouldEnable) {
    setConsoleLogEnabled(true)
    log.removeSinks(ConsoleLogSink.name)
    log.addSink(new ConsoleLogSink())
  }
}

export type InitLogOptions = {
  customMetadata?: CustomLogData
  customSessionId: string
  contentStorageUrl?: string
  enableFullEvents?: boolean
}

export function initLog(
  otelConfig: OTelConfig,
  {
    customMetadata,
    customSessionId,
    contentStorageUrl,
    enableFullEvents,
  }: InitLogOptions,
  telemetrySink?: TelemetrySink
): void {
  log.clearSinks()

  const config: IConfiguration = setupConfiguration(
    customMetadata,
    customSessionId,
    contentStorageUrl
  )
  //  Add prod sinks
  if (config.Environment === Environment.Prod) {
    initializeOtelWebLogger(
      otelConfig,
      telemetrySink,
      customSessionId,
      enableFullEvents
    )
  }

  initConsoleLog()
}
